import { getApplicationFormValues } from "./getApplicationFormValues";

export const getRegistrationAddress = () => {
  const formValues = getApplicationFormValues();

  return formValues.registration_address && formValues.registration_address.data || {}
};
